import ApiSso from "./sso";


class userValidate {

    async validate(password, repeat_password, phone, cpf){
        
        if(password !== repeat_password){
            return {
                status: false,
                message: 'As senhas não conferem',
                error: 'password'
            }
        }

        if(phone.length < 10){
            return {
                status: false,
                message: 'Preencha um número de telefone válido.',
                error: 'phone'
            };
        }

        if(cpf.length < 11){
            return {
                status: false,
                message: 'Preencha um número de CPF válido.',
                error: 'cpf'
            };
        }

        return {status: true, message: 'Tudo ok!'};

    }

}
export default new userValidate();